export default function buildFilesFormData(files: File[]) {
  const formData = new FormData();

  for (let file of files) {
    formData.append('file', file, file.name);
  }

  return formData;
}
